
export class SoccerPlaygroundDimensions {
    static readonly PlaygroundWith: number = 68.0;
    static readonly PlaygroundHeight: number = 105.0;

    static readonly PlaygroundHalfHeight: number = SoccerPlaygroundDimensions.PlaygroundHeight / 2.0
    static readonly GoalWidth = 7.32;

    static readonly PenaltyZoneHeight: number = 16.5;
    static readonly PenaltyZoneWidth: number = 2.0 * SoccerPlaygroundDimensions.PenaltyZoneHeight + SoccerPlaygroundDimensions.GoalWidth;
    
    static readonly GoalZoneHeight: number = 5.5;
    static readonly GoalZoneWidth: number = 2.0 * SoccerPlaygroundDimensions.GoalZoneHeight + SoccerPlaygroundDimensions.GoalWidth;
    
    static readonly PenaltyPoint: number = 11.0;
    
    static readonly DistanceRadius = 9.15;
    static readonly CornerArcRadius = 1.0;

    
}
